import type { LoggerService } from "@/services/abstract/LoggerService";
import { makeMessageHandler } from "@/services/poc/handlers/makeMessageHandler";

export const createFileReplicationProgressHandler = (loggerService: LoggerService) =>
  makeMessageHandler(
    'fileReplicationProgress',
    'six3ro:p2p:handlers:file-replication-progress',
    loggerService,
    (message) => ({
      type: 'fileReplicationProgress',
      data: {
        cid: message.cid,
        sixId: message.sixId,
        stage: message.stage,
        bytesTransferred: message.bytesTransferred,
        totalBytes: message.totalBytes,
        sender: message.sender,
        messageTimestamp: message.timestamp,
      },
    })
  );
